import type { AddressBookType } from '~/domains/actions/types'

/** Ids of the backend `UserGroup` enum */
export const UserGroupId = {
  Admin: 1,
  Consultant: 6,
  Recruiter: 7
} as const

type UserWithGroups = { groups: { id: number }[] } | null | undefined

/** `user` is the SPA context; on a CakePHP page (no provider) the groups come from `JobConfig`. */
const hasGroup = (user: UserWithGroups, id: number): boolean =>
  (user?.groups ?? window.JobConfig?.user.availableGroups ?? []).some(
    (group) => group.id === id
  )

/** Applicants are the recruiters' business, contacts the consultants'; an admin has both. */
export const canAccessApplicants = (user: UserWithGroups): boolean =>
  hasGroup(user, UserGroupId.Admin) || hasGroup(user, UserGroupId.Recruiter)

export const canAccessContacts = (user: UserWithGroups): boolean =>
  hasGroup(user, UserGroupId.Admin) || hasGroup(user, UserGroupId.Consultant)

/** Kinds of persons the user may link to an action, in the address book order */
export const accessiblePersonTypes = (
  user: UserWithGroups
): Extract<AddressBookType, 'applicant' | 'contact'>[] => [
  ...(canAccessApplicants(user) ? (['applicant'] as const) : []),
  ...(canAccessContacts(user) ? (['contact'] as const) : [])
]
